import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { insertTrackEvent } from '@comeon/analytics';
import { selectPromotionsIsAvailableForUser } from '~/components/promotions/ducks/selectors';
import { authenticationSelector } from '~/components/authentication/ducks/selectors';
import { fetchPromotionsAvailability } from '~/components/promotions/ducks/promotions-duck';
import { FilterLink, StyledExternalLink } from '~/components/header/filters.js';

interface LinkFreeToPlayProps {
	label: string;
	route: string;
	customF2Ppath: string;
	product: string;
	oldEnough?: boolean;
	isSelfExcluded?: boolean;
	onClick: () => void;
}

const LinkFreeToPlay = ({
	label,
	onClick,
	route,
	customF2Ppath,
	product,
	oldEnough,
	isSelfExcluded
}: LinkFreeToPlayProps) => {
	const dispatch = useDispatch();
	const f2pAvailableForUser = useSelector(selectPromotionsIsAvailableForUser);
	const authenticated = useSelector(authenticationSelector);

	useEffect(() => {
		if (authenticated) {
			dispatch(fetchPromotionsAvailability() as unknown as AnyAction);
		}
	}, [authenticated, dispatch]);

	if (f2pAvailableForUser || !authenticated) {
		if (oldEnough && !isSelfExcluded)
			return (
				<FilterLink
					key={`navbar-${product}`}
					href={`${route}/${encodeURIComponent(customF2Ppath)}`}
					data-at="free-to-play"
					retainCase
					activeMatch={route}
					onClick={() => {
						insertTrackEvent({
							category: 'Top Nav Item',
							action: 'Click',
							label: 'free-to-play'
						});
					}}
				>
					{label}
				</FilterLink>
			);
		return <StyledExternalLink key={`navbar-${product}`} data-at="free-to-play" onClick={() => onClick()} />;
	}
	return null;
};

export default LinkFreeToPlay;
